export class TypeModel {
  value: string;

  constructor(value?: string) {
    this.value = value;
  }
}
